var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3216 22.6589C29.3216 23.3658 29.0407 24.0438 28.5409 24.5437C28.041 25.0436 27.363 25.3244 26.656 25.3244H9.10067C8.39378 25.3246 7.71589 25.6055 7.21612 26.1055L4.28134 29.0402C4.149 29.1725 3.98041 29.2627 3.79686 29.2992C3.61332 29.3357 3.42308 29.3169 3.25018 29.2453C3.07729 29.1737 2.92951 29.0524 2.82553 28.8968C2.72155 28.7412 2.66604 28.5583 2.66602 28.3712V6.66556C2.66602 5.95861 2.94685 5.28061 3.44674 4.78072C3.94663 4.28083 4.62462 4 5.33157 4H26.656C27.363 4 28.041 4.28083 28.5409 4.78072C29.0407 5.28061 29.3216 5.95861 29.3216 6.66556V22.6589Z",
    stroke: "white",
    strokeWidth: 2.66556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.533ff54c899be2f32e7ae6f81b396295.svg";
export { ForwardRef as ReactComponent };